import React from 'react';
import { reportError } from '../../apis/reportError';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        //logErrorToMyService(error, errorInfo);
        console.log('Global Error', error, errorInfo);
        try {
            reportError(window.restauId, window.email, {
                msg: 'App stopped.',
                error,
            });
        } catch (e) {}
        //window.location.reload();
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <h1>Something went wrong. Restart app.</h1>;
        }

        return this.props.children;
    }
}
